const hlxLogoAlt = require('./assets/hlx-logo-alt.jpg');
const sklsiLogo = require('./assets/sklsi-logo.png');

export default {
  sobix: {
    clientName: 'HELIX',
    customHeaderLogo: hlxLogoAlt
  },
  sklsi: {
    headerTitle: 'Educational Peer Event Registration',
    customHeaderLogo: sklsiLogo
  }
};
